import { render, staticRenderFns } from "./ed-presentation-mode-share-toggle.component.vue?vue&type=template&id=4aefee58&scoped=true&"
import script from "./ed-presentation-mode-share-toggle.component?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-share-toggle.component?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-share-toggle.component.scss?vue&type=style&index=0&id=4aefee58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefee58",
  null
  
)

export default component.exports